<template>
  <div class="rating" :class="{ 'rating-decimal': isDecimal }" @click="$emit('click')">
    <Icon v-for="rate in formatedRates" :key="rate" icon="star" class="star" />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon,
  },
  props: {
    value: {
      type: [ String, Number ],
      required: true,
    },
  },
})
export default class Rating extends Vue {
  get rates () {
    return parseInt(this.value) / 10
  }

  get formatedRates () {
    return Math.floor(this.value / 10)
  }

  get isDecimal () {
    return this.rates % 1 !== 0
  }
}
</script>

<style lang="scss" scoped>
.rating {
  font-size: 11px;

  &-decimal {
    position: relative;

    &::after {
      content: '+';
      font-size: 24px;
      position: absolute;
      top: -10px;
      font-weight: lighter;
    }
  }

  .star {
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Rating.vue